import EntityImageActions from '../../entityImage/EntityImageActions';

const CompanyImageActions = () => <EntityImageActions entityType="company" />;

export default CompanyImageActions;
